// LLM generated - Model Claude 4 Sonnet
import { Group, Stack, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';

type GameplayDiscardModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  changeType: 'league' | 'contestType';
  isCloseDisabled?: boolean;
};

export default function GameplayDiscardModal({
  isOpen,
  onClose,
  onConfirm,
  changeType,
  isCloseDisabled = false,
}: GameplayDiscardModalProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation('common');

  const title =
    changeType === 'league'
      ? t('modals.sportStyleChange.league.title')
      : t('modals.sportStyleChange.contestType.title');

  const description =
    changeType === 'league'
      ? t('modals.sportStyleChange.league.description')
      : t('modals.sportStyleChange.contestType.description');

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Stack spacing={theme.other.spacing._8} p={theme.other.spacing._32} align="center">
        <Title tag="h2" variant="headline-xl" align="center" maw={300}>
          {title}
        </Title>

        <Text
          variant="body-large"
          align="center"
          maw={400}
          mb={theme.other.spacing._24}
          c={theme.colors.gray2[3]}
        >
          {description}
        </Text>

        <Stack spacing={theme.other.spacing._16} w="100%">
          <Button variant="danger-fill" onClick={handleConfirm} disabled={isCloseDisabled}>
            {t('modals.sportStyleChange.confirmLabel')}
          </Button>
          <Button variant="tertiary-fill" onClick={onClose} disabled={isCloseDisabled}>
            {t('modals.sportStyleChange.cancelLabel')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
